import { useState, useEffect, useMemo } from 'react';

// ID do canal MEVAM Brasília
const CHANNEL_ID = 'UC2ILVabVRlfIsD8GYd4Rflw';

// Lista de proxies CORS para fallback
const CORS_PROXIES = [
  'https://api.allorigins.win/raw?url=',
  'https://corsproxy.io/?',
  'https://api.codetabs.com/v1/proxy?quest='
];

const useYouTubeVideos = (limit = 6) => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Vídeos fixos como fallback - últimos vídeos/streams do canal
  const fallbackVideos = useMemo(() => [
    {
      id: 'SWu43r8DSy8',
      titulo: 'A FALSA ESPERANÇA GERA SOFRIMENTO',
      thumbnail: 'https://img.youtube.com/vi/SWu43r8DSy8/maxresdefault.jpg',
      data: '10 nov 2025',
      categoria: 'Pregação',
      duracao: '50:23',
      pregador: 'Pastor Anderson Rabis'
    },
    {
      id: 'm9idPlqvjfI',
      titulo: 'MISSÃO CENTRO OESTE, COM O APOSTOLO LUIZ HERMÍNIO',
      thumbnail: 'https://img.youtube.com/vi/m9idPlqvjfI/maxresdefault.jpg',
      data: '12 out 2025',
      categoria: 'Conferência',
      duracao: '2:37:56',
      pregador: 'Apostolo Luiz Hermínio'
    },
    {
      id: 'F6bOxLXKoMc',
      titulo: 'OBEDIÊNCIA, POSICIONAMENTO E ENFRETAMENTO',
      thumbnail: 'https://img.youtube.com/vi/F6bOxLXKoMc/maxresdefault.jpg',
      data: '01 jul 2025',
      categoria: 'Pregação',
      duracao: '1:00:38',
      pregador: 'Pastor Anderson Rabis'
    },
    {
      id: 'd81iECeTZ48',
      titulo: 'COMO VENCER AS VOZES DE INTIMIDAÇÃO',
      thumbnail: 'https://img.youtube.com/vi/d81iECeTZ48/maxresdefault.jpg',
      data: '15 set 2025',
      categoria: 'Pregação',
      duracao: '1:05:45',
      pregador: 'Pastor Anderson Rabis'
    },
    {
      id: 'xBIKHX3eYNA',
      titulo: 'Palavra Profética',
      thumbnail: 'https://img.youtube.com/vi/xBIKHX3eYNA/maxresdefault.jpg',
      data: '22 jul 2025',
      categoria: 'Pregação',
      duracao: '45:20',
      pregador: 'Pastor Anderson Rabis'
    },
    {
      id: 'yhDWI6DjH10',
      titulo: 'COMUNICAÇÃO PROFÉTICA - O EVANGELHO PARA OS IMPROVÁVEIS',
      thumbnail: 'https://img.youtube.com/vi/yhDWI6DjH10/maxresdefault.jpg',
      data: '27 mai 2025',
      categoria: 'Pregação',
      duracao: '48:18',
      pregador: 'Pastor Anderson Rabis'
    }
  ], []);

  useEffect(() => {
    const fetchYouTubeVideos = async () => {
      try {
        setLoading(true);
        
        // Função para tentar buscar com diferentes proxies
        const fetchWithProxy = async (url, proxyIndex = 0) => {
          if (proxyIndex >= CORS_PROXIES.length) {
            throw new Error('Todos os proxies falharam');
          }
          
          try {
            const proxy = CORS_PROXIES[proxyIndex];
            const response = await fetch(proxy + encodeURIComponent(url), {
              signal: AbortSignal.timeout(8000)
            });
            
            if (!response.ok) {
              throw new Error('Resposta não ok');
            }
            
            return await response.text();
          } catch (err) {
            console.warn(`Proxy ${proxyIndex + 1} falhou, tentando próximo...`);
            return fetchWithProxy(url, proxyIndex + 1);
          }
        };
        
        // Buscar via RSS Feed (não precisa de API Key)
        const rssFeedUrl = `https://www.youtube.com/feeds/videos.xml?channel_id=${CHANNEL_ID}`;
        const rssText = await fetchWithProxy(rssFeedUrl);
        
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(rssText, 'text/xml');
        
        // Verificar se houve erro no parsing
        if (xmlDoc.querySelector('parsererror')) {
          throw new Error('Erro ao processar feed XML');
        }
        
        const entries = Array.from(xmlDoc.querySelectorAll('entry')).slice(0, limit);
        
        if (entries.length === 0) {
          throw new Error('Nenhum vídeo encontrado no feed');
        }
        
        const fetchedVideos = entries.map(entry => {
          const videoId = entry.querySelector('videoId')?.textContent || '';
          const title = entry.querySelector('title')?.textContent || '';
          const published = entry.querySelector('published')?.textContent || '';
          
          // Formatar data
          const date = new Date(published);
          const months = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
          const dateStr = `${date.getDate().toString().padStart(2, '0')} ${months[date.getMonth()]} ${date.getFullYear()}`;
          
          // Determinar categoria baseado no título
          let categoria = 'Pregação';
          const titleLower = title.toLowerCase();
          if (titleLower.includes('convenção') || titleLower.includes('conferência') || titleLower.includes('missão')) {
            categoria = 'Conferência';
          } else if (titleLower.includes('culto profético')) {
            categoria = 'Culto Profético';
          } else if (titleLower.includes('jovens') || titleLower.includes('jovem')) {
            categoria = 'Rede de Jovens';
          } else if (titleLower.includes('celebração') || titleLower.includes('família')) {
            categoria = 'Cultos';
          }
          
          return {
            id: videoId,
            titulo: title,
            thumbnail: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
            data: dateStr,
            categoria: categoria,
            duracao: '—',
            pregador: 'MEVAM Brasília'
          };
        });
        
        setVideos(fetchedVideos);
        setError(null);
        
        // Salvar no localStorage como cache
        localStorage.setItem('mevam_home_videos', JSON.stringify(fetchedVideos));
        localStorage.setItem('mevam_home_videos_timestamp', Date.now().toString());
        
      } catch (err) {
        console.warn('Erro ao buscar vídeos do YouTube:', err.message);
        
        // Tentar usar cache primeiro
        const cachedVideos = localStorage.getItem('mevam_home_videos');
        const cacheTimestamp = localStorage.getItem('mevam_home_videos_timestamp');
        const oneDay = 24 * 60 * 60 * 1000;
        
        if (cachedVideos && cacheTimestamp && (Date.now() - parseInt(cacheTimestamp)) < oneDay) {
          console.log('Usando vídeos do cache...');
          setVideos(JSON.parse(cachedVideos));
        } else {
          // Usa vídeos fixos como fallback
          console.log('Usando vídeos de fallback...');
          setVideos(fallbackVideos.slice(0, limit));
        }
        setError(null); // Não mostra erro para o usuário
      } finally {
        setLoading(false);
      }
    };

    fetchYouTubeVideos();
  }, [limit, fallbackVideos]);

  return { videos, loading, error };
};

export default useYouTubeVideos;
